import React from 'react';
import { useParams } from 'react-router-dom';
import NotFoundPage from '../notFound/NotFoundPage';
import ProductComparisonPage from './ProductComparisonPage';

/**
 * Slugs that use Supabase-backed ProductComparisonPage at `/simple-products/:productId`
 * (same URL shape as the legacy static PDPs). Add new slugs here when migrating.
 */
export const SIMPLE_PRODUCT_DB_SLUGS = new Set([
  'echomap-73sv-uhd2',
  'echomap-93sv-uhd2',
  'echomap-ultra-2-106sv',
  'echomap-ultra-2-126sv',
  'gpsmap-8610xsv',
  'gpsmap-8612xsv',
  'gpsmap-943xsv',
  'gpsmap-1042xsv',
  'gpsmap-1242xsv',
  'gpsmap-1243xsv',
  // Transducers (DB-backed PDPs)
  'garmin-lvs34',
  'gt54uhd-chirp',
  'gt56uhd-chirp',
  'gt8hw-if',
  'gt10hn-if',
  'panoptix-ps22',
  'panoptix-ps30-down',
  'livescope-plus-lvs34',
  'livescope-plus-lvs34-ice',
  'garmin-livescope-plus-lvs34',
  'livescope-xr-lvs62',
  'livescope-2-lvs44',
  'livescope-2-lvs42hd',
  'livescope-2-lvs42hd-ice',
]);

export function isKnownSimpleProductSlug(productId) {
  return Boolean(productId && SIMPLE_PRODUCT_DB_SLUGS.has(productId));
}

/**
 * Routes `/simple-products/:productId` to a known DB-backed PDP.
 * Unknown slugs render Not Found instead of fabricating a product page.
 * Dedicated static accessory / bundle routes are declared in App.js and win first.
 */
export default function SimpleProductEntry() {
  const { productId } = useParams();
  if (isKnownSimpleProductSlug(productId)) {
    return <ProductComparisonPage />;
  }
  return <NotFoundPage />;
}
